require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projecten-kinderboerderij.json") })
        }
      }, "path---projecten-kinderboerderij");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---projecten-kinderboerderij!./.cache/json/projecten-kinderboerderij.json
// module id = 423
// module chunks = 231608221292675